import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface SaveGameIconProps extends ISvgIconProps {
    shouldFill?: boolean;
}

export class SaveGameIcon extends React.Component<SaveGameIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} fill={this.props.shouldFill ? "white" : "transparent"} viewBox="0 0 22 22" >
            <mask id="mask0_9821_214528"  maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
                <path d="M0 0H22V22H0V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9821_214528)">
                <path d="M5.27275 0.999999C4.93541 0.999999 4.61095 1.14033 4.37231 1.39066C4.13364 1.64066 4 1.97967 4 2.33332V20.0887C4 20.592 4.38819 21 4.86864 21H4.87184C5.12957 21 5.37454 20.8927 5.55591 20.702C6.39908 19.8193 8.88727 17.2127 9.91501 16.138C10.2014 15.8363 10.5927 15.6667 11 15.6667C11.4073 15.6667 11.7987 15.8363 12.085 16.138C13.1159 17.216 15.6168 19.8354 16.4505 20.71C16.6286 20.8957 16.8672 21 17.1186 21C17.6055 21 18 20.587 18 20.0773V2.33332C18 1.97967 17.8664 1.64066 17.6277 1.39066C17.3891 1.14033 17.0646 0.999999 16.7272 0.999999H5.27275Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </SvgIcon>;
    }
}
